var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"bread-adjust grey darken-4",attrs:{"flat":"","dense":"","dark":""}},[_c('v-breadcrumbs',{attrs:{"dark":"","items":_vm.items,"divider":"/"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }